
export enum OnlineBriefingBannerStyleEnum {
    SIMPLE = 'SIMPLE',
    IMAGE_GRID = 'IMAGE_GRID',
    NO_IMAGE = 'NO_IMAGE'
};
